export enum PlayerStatus {
  // 播放中
  playing = 'playing',
  // 停止中
  stop = 'stop',
  // 暂停
  paused = 'paused',
  // 销毁
  destroyed = 'destroyed',
  // 结束播放
  end = 'end',
  // 拖拽播放
  seek = 'seek',
  // 错误
  error = 'error'
}

export const ErrorCode = {
  sourceError: { message: '媒体没有提供播放资源，无法正常播放', code: 2000 }
}
